import { render, staticRenderFns } from "./BomForwardDeployCustomer.vue?vue&type=template&id=596fdc96&"
import script from "./BomForwardDeployCustomer.vue?vue&type=script&lang=js&"
export * from "./BomForwardDeployCustomer.vue?vue&type=script&lang=js&"
import style0 from "./BomForwardDeployCustomer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports